var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#242424",
    width: 6.558,
    height: 7.564,
    viewBox: "0 0 6.558 7.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.838,7.488,2.675,3.956a.258.258,0,0,1,0-.349L5.838.076a.2.2,0,0,1,.313,0L6.49.455A.258.258,0,0,1,6.49.8L3.822,3.782,6.49,6.761a.258.258,0,0,1,0,.349l-.339.378a.2.2,0,0,1-.313,0Zm-2.607,0L.067,3.956a.259.259,0,0,1,0-.349L3.231.076a.2.2,0,0,1,.312,0l.34.379a.258.258,0,0,1,0,.349L1.215,3.782,3.883,6.761a.258.258,0,0,1,0,.349l-.34.378a.2.2,0,0,1-.312,0Z",
    transform: "translate(6.558 7.564) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableNext);
export default __webpack_public_path__ + "static/media/table-next.25165930.svg";
export { ForwardRef as ReactComponent };